import { IAssetTypes } from 'types/assets'
import { LABELS } from 'types/lib/labels'
import { TEMPLATE_NAME } from 'types/lib/templates'
import { isHaier2CardTemplate } from 'utils/templateUtils'

export function isSchneider(brand: string): boolean {
  return ['FD', 'IA', 'PP'].includes(brand)
}

export function isTestBrand(brand: string): boolean {
  return brand === 'Test Brand' || brand === 'Demo'
}

export function isCandy(brand: string): boolean {
  return brand === 'Candy'
}

/** Product form: banner / packshot headline fields (Candy + Haier card templates). */
export function showsProductTitleSubtitle(brand?: string): boolean {
  if (!brand) return false

  return isCandy(brand) || brand === 'Haier'
}

/** Haier card templates (Haier, Haier2, HaierTV). */
export function isHaierBrand(brand?: string): boolean {
  if (!brand) return false

  return ['Haier', 'Haier2', 'HaierTV'].includes(brand)
}

/** Product form + timeline label for the Photos asset section (template-aware). */
export function getPhotosSectionLabel(
  _brand?: string,
  cardTemplate?: string
): string {
  return isHaier2CardTemplate(cardTemplate)
    ? LABELS.visualisations
    : LABELS.photos
}


export function getProductFormPhotosAssetPool(
  assets: Record<string, IAssetTypes | undefined> | undefined
): IAssetTypes | undefined {
  if (!assets) {
    return undefined
  }

  return getPhotosCategoryAsset(assets)
}

function getPhotosCategoryAsset(
  assets: Record<string, IAssetTypes | undefined>
): IAssetTypes | undefined {
  if (assets.photos) {
    return assets.photos
  }

  const photosKey = Object.keys(assets).find(
    key => key === 'photos' || key.startsWith('photos')
  )

  return photosKey ? assets[photosKey] : undefined
}

/**
 * Category asset pool for the Slider multiselect.
 * Haier brands pick from Photos assets; PATCH still sends the `Slider` field with those UUIDs.
 */
export function getProductFormSliderAssetPool(
  brand: string | undefined,
  assets: Record<string, IAssetTypes | undefined> | undefined
): IAssetTypes | undefined {
  if (!assets) {
    return undefined
  }

  if (isHaierBrand(brand)) {
    return getPhotosCategoryAsset(assets) ?? assets.slider
  }

  return assets.slider
}

/** Slider section + payload: Haier brand only with Haier2 card template; other brands use Slider asset type. */
export function shouldShowProductFormSliderSection(
  brand: string | undefined,
  cardTemplate: string | undefined,
  assets: Record<string, IAssetTypes | undefined> | undefined
): boolean {
  if (brand === TEMPLATE_NAME.HAIER) {
    return (
      isHaier2CardTemplate(cardTemplate) &&
      Boolean(getProductFormSliderAssetPool(brand, assets))
    )
  }

  return Boolean(assets?.slider)
}

/** @deprecated Use {@link shouldShowProductFormSliderSection} with card template. */
export function shouldIncludeSliderInProductPayload(
  brand: string | undefined,
  assets: Record<string, IAssetTypes | undefined> | undefined,
  cardTemplate?: string
): boolean {
  return shouldShowProductFormSliderSection(brand, cardTemplate, assets)
}

/** Haier, HaierTV, Hoover, Candy — shared internal-only product form fields */
export function isHaierHooverCandy(brand: string): boolean {
  return ['Haier', 'HaierTV', 'Hoover', 'Candy'].includes(brand)
}
